module.exports = __webpack_public_path__ + "static/media/SmartPub-arrow-right.71c0c515.svg";